// TODO delete after clinic settings full react migration
import angular from 'angular';
import _ from 'lodash';
import { DEFAULT_KEY_INDEX } from '../../modules/settings/tabs/clinic-settings/landing-page-rooms/components/landing-page-rooms-check-in/landing-page-rooms-check-in.helper';
// keys used for translations
// patient.modal.your-name
// patient.modal.patient-name
// patient.modal.your-name
// patient.modal.your-name
const keys = ['your-name', 'patient-name', 'your-fullname', 'patient-fullname'];
const options = [];
export class CheckInPlaceholderService {
    constructor($translate) {
        this.$translate = $translate;
        this._initOptions();
    }
    _initOptions() {
        _.each(keys, (key) => {
            options.push({
                key,
                label: this.$translate.instant(`patient.modal.${key}`, {}, undefined),
            });
        });
    }
    getOptions() {
        return options;
    }
    getText(key) {
        const foundOption = options.find((option) => option.key === key);
        return foundOption ? foundOption.label : this.getDefaultOption().label;
    }
    getDefaultOption() {
        return options[DEFAULT_KEY_INDEX];
    }
}
export default angular
    .module('doxy.common.services.checkInPlaceholderService', [])
    .service('checkInPlaceholderService', CheckInPlaceholderService).name;
